
<div class="fade-in">

  <app-page-header title="Change Name" [useBrowserBack]="true"></app-page-header>
  <div class="page">
    <div *ngIf="!isLoading">
      <!--body-->
      <form #callboxForm="ngForm" name="callbox" (submit)="save(callboxForm)">

        <div class="mb-3">
          <label class="form-label">New Name</label>
          <input class="form-control" type="text" required name="name" [(ngModel)]="name" />
          <div class="text-danger text-sm" *ngIf="isSubmitted && callboxForm.form.invalid">
            Please fill out all fields
          </div>
          <div class="text-danger text-sm" *ngIf="errMsg != null">
            {{errMsg}}
          </div>
        </div>

        <div>
          <button class="btn btn-primary btn-block">Save</button>
        </div>
      </form>
    </div>
    <div *ngIf="isLoading">
      <app-page-loader></app-page-loader>
    </div>
  </div>
</div>

